<template>
  <div>
    <v-container>
      <div>
        <div>
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs6>
              <div>
                <v-pagination
                  :total-visible="15"
                  v-model="pageNumber"
                  @input="changePage"
                  :length="pagelength"
                ></v-pagination>
              </div>
            </v-flex>
            <v-flex class="text-xs-right">
              <div style="position: relative" class="form-control">
                <input
                  @keyup.enter="getData"
                  class="mb-0"
                  placeholder="Search"
                  v-model="filter.search"
                  type="text"
                />
                <v-btn
                  @click="getData"
                  :loading="loading"
                  style="position: absolute; right: 5px; top: 5px"
                  class="ma-0"
                  icon
                  ><v-icon color="primary">search</v-icon></v-btn
                >
              </div></v-flex
            >
          </v-layout>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                {{ props.item.campaign }}
              </td>

              <td class="text-xs-center">
                <v-btn
                  @click="
                    detaildata = props.item
                    modaldetail = true
                  "
                  color="primary"
                  flat
                >
                  ดูข้อมูล</v-btn
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div>
        <v-dialog v-model="modaldetail" width="600px" persistent>
          <v-card v-if="modaldetail">
            <CampaignDetail @close="modaldetail = false" :detaildata="detaildata"></CampaignDetail>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CampaignDetail from './CampaignDetail.vue'
export default {
  components: {
    CampaignDetail
  },
  data() {
    return {
      items: [],
      filter: { search: '' },
      loading: false,
      detaildata: '',
      modaldetail: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '-1' },
      headers: [
        { text: 'ชื่อ Campaign', value: 'campaign', align: 'center' },
        { text: '', value: '', align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,

        limit: this.limit,
        offset: this.offset
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          if (key == 'status') {
            Object.assign(data, { [key]: this.filter[key].value })
          } else {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }
      }
      this.loading = true
      api.getYasaleCampaign(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/campaign/main.vue